
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Doorpatition() {



  const cardData =
  {
    keyword: ' Door Partition Services',
    heading: 'Anjali Enterprises: Door Partition Services ',
    headingDescription: 'Anjali Enterprises is a trusted provider of door partition services in Pune, specializing in creating functional and stylish door partition solutions for both residential and commercial spaces. Our door partition services are designed to enhance the privacy, aesthetics, and functionality of your space, whether it’s an office, home, or commercial establishment.',

    topPlaces: [
        {
          title: "Aluminum Door Partitions",
          description: "We offer high-quality aluminum door partitions that are durable, lightweight, and sleek. These partitions are perfect for modern offices and homes, providing a sophisticated touch while maintaining privacy and functionality."
        },
        {
          title: "Glass Door Partitions",
          description: "Our glass door partitions are designed to create elegant and open spaces while maintaining privacy. They are ideal for offices and commercial spaces, providing a modern and transparent look that fosters collaboration and light flow."
        },
        {
          title: "Custom Door Partitions",
          description: "At Anjali Enterprises, we specialize in creating custom door partitions to meet your specific design and functional needs. Whether you need a unique style or particular material, we deliver tailored solutions that align with your vision."
        },
        {
          title: "Office Door Partition Installation",
          description: "Our team offers professional office door partition installation, ensuring a smooth and efficient process. We work closely with clients to create functional and aesthetically pleasing office spaces with high-quality door partitions."
        },
        {
          title: "Door Partition Work in Pune",
          description: "As a leading service provider in Pune, we handle all aspects of door partition work, from consultation to installation. Whether you need a simple partition or a complex design, our expert team guarantees precision and quality."
        },
        {
          title: "Modern Door Partitions",
          description: "Stay ahead with our modern door partitions, combining innovative designs and premium materials. These partitions are perfect for creating contemporary and stylish spaces, both at home and in the office."
        },
        {
          title: "Wooden Door Partitions",
          description: "For a classic and warm look, we provide wooden door partitions that add a touch of elegance to any space. Ideal for homes and offices, wooden partitions offer durability and timeless beauty."
        },
        {
          title: "Sliding Door Partition for Office",
          description: "Maximize space with sliding door partitions for your office. These partitions are ideal for offices with limited space, offering flexibility and easy movement while maintaining a sleek appearance."
        },
        {
          title: "Partition Door Installation",
          description: "Our professional installation team ensures the seamless installation of partition doors, taking care of all technical and aesthetic requirements. We focus on delivering high-quality, functional, and visually pleasing results."
        },
        {
          title: "Door Partition for Home and Office",
          description: "Anjali Enterprises provides door partition solutions for both homes and offices. Whether you’re looking to create private spaces at home or enhance your office layout, our door partitions offer the perfect solution for privacy and style."
        },
        {
          title: "Pune Door Partition Service",
          description: "As one of Pune’s leading door partition service providers, we are known for delivering high-quality installations with attention to detail. Our services ensure that your space is optimized for both functionality and aesthetics."
        }
      ],
      tableData: [
        ["- Aluminum Door Partitions", "- Glass Door Partitions"],
        ["- Custom Door Partitions", "- Office Door Partition Installation"],
        ["- Door Partition Work in Pune", "- Modern Door Partitions"],
        ["- Wooden Door Partitions", "- Sliding Door Partition for Office"],
        ["- Partition Door Installation", "- Door Partition for Home and Office"],
        ["- Pune Door Partition Service", ""]
      ],


    "whychoose": [
  {
    "WhyChooseheading": "Expert Door Partition Services",
    "WhyChoosedescription": "At Anjali Enterprises, we have years of expertise in providing high-quality door partition solutions tailored for both residential and commercial spaces. We offer a wide variety of partition styles, including sliding, hinged, and folding door systems, each designed to maximize your space, enhance privacy, and align perfectly with your office or home’s aesthetics. Our door partitions are made to seamlessly integrate into any environment, providing the perfect balance between function and style."
  },
  {
    "WhyChooseheading": "Custom Designs",
    "WhyChoosedescription": "We understand that every space is unique, and we are committed to offering bespoke door partition solutions that perfectly fit your design preferences and spatial needs. Whether you're looking for a sleek, modern design, or a more traditional approach, we provide fully customized partitions in various materials such as wood, glass, and aluminium. From color options to the final style, we work with you to create a partition that complements your vision, ensuring that your space looks polished and functional."
  },
  {
    "WhyChooseheading": "Durability and Functionality",
    "WhyChoosedescription": "Durability and functionality are at the core of our door partition solutions. Made from high-quality materials like toughened glass, wood, and premium aluminium, our partitions are engineered to withstand the test of time, even in high-traffic areas. Whether for your office, commercial property, or home, our partitions maintain their structural integrity, offering reliable, long-lasting use. These partitions are designed to be easy to maintain, ensuring that your investment continues to add value to your space for years to come."
  },
  {
    "WhyChooseheading": "Space Optimization",
    "WhyChoosedescription": "Our door partitions are specifically designed to optimize your available space without compromising on aesthetics. Whether you are looking to divide large open areas or maximize privacy within smaller rooms, our solutions offer functional, stylish ways to create defined spaces. By incorporating sliding, folding, or hinged partitions, we help you make the most of your area, enhancing flow and accessibility while maintaining an open, airy atmosphere. This adaptability is perfect for both offices and homes looking to balance privacy and openness."
  },
  {
    "WhyChooseheading": "Affordable Pricing",
    "WhyChoosedescription": "At Anjali Enterprises, we believe in providing high-quality door partition solutions at competitive and affordable prices. We offer a wide range of options to suit different budgets, ensuring that you get the best possible value for your investment. Our transparent pricing means there are no hidden costs, and we are always upfront about the scope of the project. Whether you need a single partition or a comprehensive solution for a large space, our pricing ensures that you can get the perfect partition without breaking the bank."
  },
  {
    "WhyChooseheading": "Timely Installation",
    "WhyChoosedescription": "We understand the importance of time when it comes to your home or office renovation projects. That’s why we prioritize timely delivery and installation of your door partitions. Our experienced team works efficiently to ensure that your partitions are installed with minimal disruption to your daily routine. We strive to complete every project on schedule while maintaining the highest standards of quality. This efficiency helps you enjoy your newly partitioned space without unnecessary delays."
  },
  {
    "WhyChooseheading": "Professional Team",
    "WhyChoosedescription": "Our team at Anjali Enterprises consists of skilled professionals with years of experience in designing, fabricating, and installing door partitions. We offer a comprehensive service, starting from the initial consultation and design phase to the final installation. We take pride in our professionalism and attention to detail, ensuring that your vision is executed to perfection. With our team of experts by your side, you can trust that your door partitions will be installed smoothly, meeting your expectations and the highest industry standards."
  },
  {
    "WhyChooseheading": "Customer Satisfaction",
    "WhyChoosedescription": "Customer satisfaction is at the heart of everything we do at Anjali Enterprises. With a strong track record of satisfied clients and numerous referrals, we are dedicated to providing door partition solutions that not only meet but exceed your expectations. We pride ourselves on our ability to listen to our customers' needs, offering personalized solutions and a hassle-free experience from start to finish. Our commitment to high-quality products, timely service, and exceptional customer care ensures that every project is a success."
  }
]



  }

  const faqData = [
    {
      question: "What types of door partitions do you offer?",
      answer: "We offer various types of door partitions, including sliding, hinged, folding, and bi-fold partitions, all available in a range of materials like glass, wood, and aluminium."
    },
    {
      question: "Can you customize door partitions according to my requirements?",
      answer: "Yes, we provide fully customized door partition solutions to suit your specific space, design preferences, and functionality needs."
    },
    {
      question: "How long does it take to install a door partition?",
      answer: "Installation time depends on the complexity and size of the project. However, we ensure timely installation with minimal disruption to your space."
    },
    {
      question: "Are the door partitions durable?",
      answer: "Yes, all our door partitions are made with high-quality materials that ensure durability, functionality, and longevity, even with regular use."
    },
    {
      question: "How do I get a quote for door partition installation?",
      answer: "Simply contact us for a free consultation, and we’ll provide you with a detailed, transparent quote based on your requirements."
    },
    {
      question: "Do you offer door partitions for both residential and commercial spaces?",
      answer: "Yes, we offer door partition solutions for both residential and commercial spaces, including offices, homes, and retail outlets."
    },
    {
      question: "Can the door partitions be installed in existing spaces?",
      answer: "Yes, our team specializes in retrofitting door partitions into existing spaces, ensuring a seamless integration with your current setup."
    },
    {
      question: "Are there any maintenance requirements for door partitions?",
      answer: "Our door partitions are designed to be low-maintenance. We recommend periodic cleaning and checks to ensure they continue to function smoothly over time."
    },
    {
      question: "Can I get a design consultation for door partitions?",
      answer: "Yes, we offer free design consultations to help you choose the best door partition solution based on your space, needs, and aesthetic preferences."
    },
    {
      question: "What makes Anjali Enterprises stand out from other partition service providers?",
      answer: "Anjali Enterprises stands out due to our focus on customer satisfaction, quality materials, custom solutions, and timely installation. We are dedicated to delivering partitions that enhance the functionality and beauty of your space."
    }
  ];
  
  const testimonials = [
    {
      name: "Mr. Kunal Mehta",
      text: "We wanted a stylish door partition for our office, and Anjali Enterprises exceeded our expectations. The sliding partition is both elegant and functional, and the installation was quick and hassle-free. Highly recommend their services!"
    },
    {
      name: "Mrs. Priya Soni",
      text: "The door partition installed in our home has completely transformed the look of our space. It's durable, easy to use, and fits perfectly with our decor. Anjali Enterprises did a fantastic job!"
    }
  ];
  



  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>



<Helmet>
  <title>Door Partition Services in Pune | Anjali Enterprises</title>
  <meta name="description" content="Anjali Enterprises provides professional door partition services in Pune, including aluminum, glass, wooden, and sliding door partitions for both home and office spaces. Call +91 8793220265 for installations and custom solutions." />
  <meta name="keywords" content="Door Partition Services, Aluminum Door Partitions, Glass Door Partitions, Custom Door Partitions, Office Door Partition Installation, Door Partition Work Pune, Modern Door Partitions, Wooden Door Partitions, Sliding Door Partition for Office, Partition Door Installation, Door Partition for Home and Office, Pune Door Partition Service" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Door Partition Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises provides professional door partition services in Pune, including aluminum, glass, wooden, and sliding door partitions for both home and office spaces. Call +91 8793220265 for installations and custom solutions." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/door-partition-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/door-partition" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises provides professional door partition services in Pune, including aluminum, glass, wooden, and sliding door partitions for both home and office spaces. Call +91 8793220265 for installations and custom solutions.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/door-partition",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/door-partition-service.jpg",
        "priceRange": "₹2000 - ₹15000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/door-partition",
          "priceCurrency": "INR",
          "price": "2000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.5",
          "reviewCount": "40"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vikram P"
            },
            "datePublished": "2024-08-25",
            "reviewBody": "Anjali Enterprises installed sliding door partitions for our office. The quality of work was exceptional, and the team was very professional. Highly recommend!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Meera K"
            },
            "datePublished": "2024-11-10",
            "reviewBody": "We had wooden door partitions installed in our home. The workmanship was great, and the doors fit perfectly. A reliable company to work with!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/door-partition"
        },
        "keywords": "Door Partition Services, Aluminum Door Partitions, Glass Door Partitions, Custom Door Partitions, Office Door Partition Installation, Door Partition Work Pune, Modern Door Partitions, Wooden Door Partitions, Sliding Door Partition for Office, Partition Door Installation, Door Partition for Home and Office, Pune Door Partition Service"
      }
    `}
  </script>
</Helmet>


      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/3.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Doorpatition;